import React, {useState, useEffect,} from 'react'
import {Form, Input, Modal, message} from 'antd'
import {reqCancelImportOrder,} from '../../api'

const {TextArea} = Input;

function OptOrderModal(props) {
    const handleOk = () => {
        const {validateFields} = props.form;
        validateFields((errors, values) => {
            if (errors) {
                return
            }
            values.orderId = props.orderId
            values.optType = props.optType
            save(values)
        })
    };
    const save = async (data) => {
        let result;
        if (props.optType === 'cancel') {
            result = await reqCancelImportOrder(data)
        }
        if (result.code === 201) {
            props.refreshFun()
            handleCancel()
        } else {
            message.error(result.message)
        }
    }
    const handleCancel = () => {
        props.form.resetFields()
        props.onCancel();
    };
    const {getFieldDecorator} = props.form;
    return (
        <Modal title={props.optType === 'cancel' ? '取消原因' : '审核失败'}
               visible={props.visible}
               onOk={handleOk}
               onCancel={handleCancel}
               okText="确定"
               cancelText="再想想">
            <Form>
                <Form.Item>
                    {getFieldDecorator('remark', {
                        rules: [{required: true, message: '该项必填'}]
                    })(<TextArea/>)}
                </Form.Item>
            </Form>
        </Modal>
    )
}

const OptOrderModalForm = Form.create()(OptOrderModal)
export default OptOrderModalForm
